const logger = (store) => (next) => (action) => {
  console.group(action.type)
    console.log('The action: ', action)
    const returnValue = next(action)
    console.log('The new state: ', store.getState())
  console.groupEnd()
  return returnValue
}

export default logger

// TODO: Could replace this with the saga version to remove thunk: https://redux-saga.js.org/docs/advanced/FutureActions.html